import debounce from 'lodash-es/debounce';

import type { AnalyticsEvent } from '@jane/shared-ecomm/types';

type MessageType =
  | 'analyticsEvent'
  | 'authEvent'
  | 'closeModal'
  | 'disableShrinkEveryResize'
  | 'enableShrinkEveryResize'
  | 'loadingEvent'
  | 'openModal'
  | 'resizeIFrame'
  | 'resizeIFrameForModal'
  | 'restoreScrollPosition'
  | 'saveScrollPosition'
  | 'scrollTo'
  | 'scrollToTop'
  | 'shrinkNextResize'
  | 'navigationEvent'
  | 'unavailableProductsEvent';

type Args<T extends MessageType = MessageType> = {
  messageType: T;
  pathname?: string;
  setOptions?: {
    preventContainerResizing?: boolean;
    preventResizing?: boolean;
  };
} & (T extends 'analyticsEvent'
  ? { payload: AnalyticsEvent }
  : { payload?: unknown });

export const postMessageToIframeParent = ({
  messageType,
  pathname,
  payload,
  setOptions,
}: Args) => {
  const path = pathname || window.location.href;
  window.parent.postMessage(
    { messageType, payload, pathname: path, setOptions },
    '*'
  );
};

export const debouncedPostMessageToIframeParent = debounce(
  ({ messageType, payload, setOptions }: Args) =>
    postMessageToIframeParent({
      messageType,
      payload,
      setOptions,
    }),
  275
);
